import { generateIDBStores } from '../../utils/idb/stores';

export enum UserDBStores {
  Windows = 'Windows',
  Sections = 'Sections',
  Past = 'Past',
  Future = 'Future',
  // SheetHistoryMetaData = "SheetHistoryMetaData",
  Keys = 'Keys',

  EntityDBInfo = 'EntityDBInfo', // Contains active WAL
  EntityIdToNameMapSnapshot = 'EntityIdToNameMapSnapshot',
  EntityIdToNameMapWAL = 'EntityIdToNameMapWAL',

  Trash = 'Trash',
  Flags = 'Flags',
  SheetsId = 'SheetsId',
  SheetsName = 'SheetsName',
}

export enum UserKeyStore {
  MasterFeKey = 'MasterFeKey',
  UserFeKey = 'UserFeKey',
}

export enum UserStorageDataType {
  Windows = 'Windows',
  Sections = 'Sections',
  Undo = 'Undo',
  Redo = 'Redo',
  History = 'History',
  Flags = 'Flags',
}

export enum UserStorageFlags {
  ManualSaveMode = 'ManualSaveMode',
  ActiveWindowId = 'ActiveWindowId',
}

export const userDBStores = generateIDBStores(Object.values(UserDBStores));
// export const userDBStores = Object.values(UserDBStores).reduce((store, key) => {
//   store[key] = '++';
//   return store;
// }, {} as { [key: string]: string });

// export const uiDBSchema = {
//     windows: '++',
//     sections: '++',
//     keys: '++'
// }
